import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../i18n/LanguageContext';
import './AboutSection.css';
import ckanImage from '../../imgs/ckan-img3.png';

export default function AboutSection() {
  const { t } = useT();

  const STATS = [
    { value: '2004', label: t('about.statStart') },
    { value: '1B+',  label: t('about.statStreams') },
    { value: '50+',  label: t('about.statVideos') },
    { value: '30+',  label: t('about.statCollabs') },
  ];

  return (
    <section className="about">
      <div className="about__grid">
        {/* ── Media column ── */}
        <div className="about__media">
          <div className="about__media-frame">
            <img src={ckanImage} alt="C-Kan" />
            <div className="about__media-fade" />
            <div className="about__media-tag">
              <span>Guadalajara, MX</span>
              <span>·</span>
              <span>2026</span>
            </div>
          </div>
          <div className="about__media-side">
            <span className="about__vertical-text">C-KAN · EL PERRO DE LA C · OFICIAL</span>
          </div>
        </div>

        {/* ── Content column ── */}
        <div className="about__content">
          <span className="ck-eyebrow">{t('about.eyebrow')}</span>
          <h2 className="about__title">
            {t('about.titleA')} <em>{t('about.titleB')}</em>
          </h2>

          <p className="about__lead">{t('about.lead')}</p>
          <p className="about__body">{t('about.body')}</p>

          <div className="about__quote">
            <svg viewBox="0 0 24 24" width="32" height="32" aria-hidden="true">
              <path fill="currentColor" d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
            </svg>
            <p>{t('about.quote')}</p>
          </div>

          <div className="about__stats">
            {STATS.map(s => (
              <div className="about__stat" key={s.label}>
                <span className="about__stat-value">{s.value}</span>
                <span className="about__stat-label">{s.label}</span>
              </div>
            ))}
          </div>

          <Link to="/AboutMe" className="ck-btn">
            {t('about.cta')}
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
